import { render, staticRenderFns } from "./ExaminationBoardEditor.vue?vue&type=template&id=7cbac21d&scoped=true&"
import script from "./ExaminationBoardEditor.vue?vue&type=script&lang=ts&"
export * from "./ExaminationBoardEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ExaminationBoardEditor.vue?vue&type=style&index=0&id=7cbac21d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbac21d",
  null
  
)

export default component.exports